import React from 'react';
import './ContributeLKM.css';

function ContributeLKM() {
  return (
    <>
    {/* <div className="contribute-service-wrap">
        <div className="contribute-service-row">
            <p><img src="images/feedback/contact-icon-v1.svg" alt="request" />Contribute to LKM</p>
        </div>
    </div> */}
    </>
  )
}

export default ContributeLKM